import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./sass/main.scss";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import "react-calendar/dist/Calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-bootstrap-typeahead/css/Typeahead.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as Sentry from '@sentry/react';

import "./translation/i18n";
import "./Sentry";
import SentryUserProvider from "providers/SentryUserProvider";
import ErrorFallback from "components/layout/ErrorFallback";

document.addEventListener("DOMContentLoaded", () => {
  const rootElement = document.getElementById("root");
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
        <Provider store={store}>
          <SentryUserProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/*" element={<App />} />
              </Routes>
            </BrowserRouter>
          </SentryUserProvider>
        </Provider>
      </Sentry.ErrorBoundary>
    );
  } else {
    throw new Error("Root element not found. App cannot be mounted.");
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
